

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    $('.provider-list').on("click", function (){
        var clickedProvider = $(this).find('.provider-title').attr('data-title');
        $(".provider-info").addClass('d-none');

        $( ".provider-info" ).each(function() {
            var providerInfo = $(this).attr('data-title');
            if (clickedProvider == providerInfo){
                $(this).removeClass('d-none');
            }
        });
    });

    basicNavigation();


    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    if ($('.home-page-slider').length > 0){
        var total = $('.home-page-slider').length, // get the number of slides
            rand = Math.floor( Math.random() * total ); // random number

        $('.home-page-slider').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            fade: true,
            arrows: false
        });

        $('.home-page-slider').slickGoTo(rand); //navigate to random slide
    }


    $(".get-started").click(function() {
        $('html, body').animate({

            scrollTop: $(".scroll-to").offset().top - 90
        }, {
            duration: 1000,
            easing: 'easeInOutCubic'});
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    var testimonialSlider = $('.testimonial-slider');

    testimonialSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 10000,
        adaptiveHeight: true,
        dots: false,
        centerPadding: 0
    });

    $('.testimonial-prev').click(function(){
        $('.testimonial-slider').slick('slickPrev');
    });

    $('.testimonial-next').click(function(){
        $('.testimonial-slider').slick('slickNext');
    });



    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});
